import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useOrgPermissions } from "@/hooks/useOrgPermissions";

export function useFeatureFlag(key: string): boolean {
  const { orgId } = useOrgPermissions();

  const { data } = useQuery({
    queryKey: ["feature-flag", key, orgId],
    queryFn: async () => {
      const { data } = await (supabase
        .from("feature_flags" as any)
        .select("enabled_global, enabled_org_ids")
        .eq("flag_key", key)
        .maybeSingle() as any);
      return data as { enabled_global: boolean; enabled_org_ids: string[] | null } | null;
    },
    staleTime: 5 * 60 * 1000,
  });

  if (!data) return false;
  if (data.enabled_global) return true;
  if (orgId && Array.isArray(data.enabled_org_ids)) {
    return data.enabled_org_ids.includes(orgId);
  }
  return false;
}
